/**
 * 避難情報JSON取得
 */
import Repository from "./../RepositoryLocal";
import logger from "./../../lib/logger";

const resource = "";
// const timeFormat = "YYYY-MM-DD HH:mm";

export default {
  getPrefEvaList() {
    let path = "/portal/web-resource/l-alert/evacuation/list/80.json";
    logger.debug("json getPrefEvaList()");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 選択中地点の市町村避難情報取得
   * @param {*} swobsCd 危機管理型水位計番号
   */
  getSelectedEvaDetail(docId) {
    let path = "/portal/web-resource/l-alert/evacuation/detail/" + docId + ".json";
    logger.debug("json getSelectedEvaDetail(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};